export default {
    setLoadingGeo(state, b) {
        state.loadingGeo = b;
    }, setLoadingInput(state, b) {
        state.loadingInput = b;
    },
    setDirRecogerProveedor(state, p) {
        state.dirRecogerProveedor = p;
    },
    setDirRecogerInput(state, string) {
        state.dirRecogerInput = string;
    },
    setDirRecogerInputObj(state, obj) {
        state.dirRecogerInputObj = obj;
    },
    setDirRecogerInputCoordenadas(state, coords) {
        state.dirRecogerInputCoordenadas = coords;
    },
    setDirDomicilioGeoString(state, s) {
        state.dirDomicilioGeoString = s;
    },
    setDirDomicilioGeoCoordenadas(state, coord) {
        state.dirDomicilioGeoCoordenadas = coord;
    },
    setDirDomicilioGeoObj(state, obj) {
        state.dirDomicilioGeoObj = obj;
    },
    setDirDomicilioGeoObjCorregido(state, obj) {
        state.dirDomicilioGeoObjCorregido = obj;
    },
    setDirDomicilioInput(state, s) {
        state.dirDomicilioInput = s;
    },
    setDirDomicilioInputObj(state, o) {
        state.dirDomicilioInputObj = o;
    },
    setDirDomicilioCacheString(state, s) {
        state.dirDomicilioCacheString = s;
        localStorage.setItem('dirDomicilioCacheString', JSON.stringify(s));
    },
    setDirDomicilioCacheObj(state, obj) {
        state.dirDomicilioCacheObj = obj;
        localStorage.setItem('dirDomicilioCacheObj', JSON.stringify(obj));
    },
    getDirCache(state) {
        state.dirDomicilioCacheString = JSON.parse(localStorage.getItem("dirDomicilioCacheString"));
        if (localStorage.getItem("dirDomicilioCacheObj")) {
            state.dirDomicilioCacheObj = JSON.parse(localStorage.getItem("dirDomicilioCacheObj"));
        }
    },
    resetDirCache(state) {
        state.dirDomicilioCacheObj = {
            calle: '',
            numero: '',
            adicional: '',
            municipio: '',
            cp: '',
            provincia: ''
        };
        state.dirDomicilioCacheString = '';
        localStorage.removeItem('dirDomicilioCacheString');
        localStorage.removeItem('dirDomicilioCacheObj');
    },
    setDirDomicilioDialogo(state, direccion) {
        state.dirDomicilioDialogo = direccion;
    },
    setDirDomicilioDialogoOld(state, direccion) {
        state.dirDomicilioDialogoOld = direccion;
    },
    setDirDomicilioDialogSinCambios(state, b){
        state.dirDomicilioDialogSinCambios = b;
    },
    setDirDomicilioDialogoPorTipo(state, data) {
        state.dirDomicilioDialogo[data[0]] = data[1];
    },
    setDialogoDomicilioDireccion(state, b) {
        state.dialogoDomicilioDireccion = b;
    },
    setLoadingDialogDireccionDomicilio(state, b) {
        state.loadingDialogDireccionDomicilio = b;
    },
    setModoEligiendo(state, modo) {
        state.modoEligiendo = modo;
    },
    setVieneDePedidos(state, b) {
        state.vieneDePedidos = b
    },
    setLoadingRest(state, b) {
        state.loadingRest = b
    },
    setDirGeoCoordenadas(state, coord) {
        state.dirGeoCoordenadas = coord
    },
    setDirGeoString(state, s) {
        state.dirGeoString = s
    },
    setDirGeoObj(state, obj) {
        state.dirGeoObj = obj
    },
    //nuevo
    setDirPidiendo(state, dir) {
        if (dir.geolocalizacion) delete dir.geolocalizacion
        if (!dir.cacheada) dir.cacheada = true;

        state.dirPidiendo = dir
        // localStorage.setItem('dirPidiendo', JSON.stringify(dir));
    },
    setDirecciones(state, direcciones) {
        state.direcciones = direcciones;
    },

    setCoordenadasNavegador(state, data) {
        let filtro = [parseFloat(data[0]), parseFloat(data[1])]
        state.direccionNavegador.coordenadas = filtro;
    },
    setLoadingDireccionNavegador(state, dir) {
        state.loadingDireccionNavegador = dir;
    },
    setDireccionNavegador(state, dir) {
        state.direccionNavegador = dir;
    },
    setDireccionCache(state) {
        state.direccionCache = localStorage.getItem('dirPidiendo') != null ? JSON.parse(localStorage.getItem('dirPidiendo')) : {}
    },
    setDireccionInput(state, dir) {
        state.direccionInput = dir;
    },
    setMostrarDirNavegador(state, v) {
        state.mostrarDirNavegador = v;
    },
    setMostrarDirCache(state, v) {
        state.mostrarDirCache = v;
    },
    setConfirmDialog(state, v) {
        state.confirmDialog = v;
    },
    setDireccionEliminar(state, v) {
        state.direccionEliminarID = v;
    },
    resetDirecciones(state) {
        localStorage.removeItem('dirPidiendo');
        state.dirPidiendo = null;
        state.direccionInput = null;
        state.direccionNavegador = {};
    },
    setLocationSearchText(state, v) {
        state.locationSearchText = v;
    },
    setLocationEntries(state, v) {
        state.locationEntries = v;
    },
    setBuscando(state, v) {
        state.buscando = v;
    }
}